var viewImageTemplate = require('html/templates/viewImageTemplate')();

function imageModal() {

  var controller = function($scope, modal) {

    $scope.imageUrl = function(customer) {
      return customer.imageUrl;
    };

    $scope.viewImage = function(customer) {
      $scope.customer = customer;
      modal.open({
        scope: $scope,
        klass: 'viewImage',
        title: customer.name,
        body: viewImageTemplate
      });
    };

  };

  controller.$inject = ['$scope', 'modal'];

  return {
    restrict: 'E',
    replace: true,
    scope: { customer: '=' },
    template: '<span class="viewImage" ng-click="viewImage(customer)" />',
    controller: controller
  };

}

module.exports = imageModal;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/imageModal.js
 ** module id = 143
 ** module chunks = 1
 **/